import { render, staticRenderFns } from "./fp-travel.vue?vue&type=template&id=6fd9f606&"
import script from "./fp-travel.vue?vue&type=script&lang=js&"
export * from "./fp-travel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd9f606')) {
      api.createRecord('6fd9f606', component.options)
    } else {
      api.reload('6fd9f606', component.options)
    }
    module.hot.accept("./fp-travel.vue?vue&type=template&id=6fd9f606&", function () {
      api.rerender('6fd9f606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/fp-travel.vue"
export default component.exports